import { ResolveResource } from './utils'
import Factory from './utils/Factory'
const resource = ResolveResource(__filename)
import fetch from '@/fetch'

export default new Factory(resource, {
  login(payload = {}) {
    let { email } = payload
    return fetch('/api/contact/send/login/', { method: 'POST', body: JSON.stringify({ email }), credentials: 'omit' })
  },
  contractPrefill(payload) {
    let { id } = payload
    return fetch(`/api/contact/${id}/contract-prefill`).then(res => res.json())
  },
  emailAvailable(payload = {}) {
    let { email } = payload
    return fetch('/api/contact/validate/' + email)
  },
  setScopes(id, payload = {}) {
    return fetch(`/api/contact/${id}/scopes`, {
      method: 'POST',
      body: JSON.stringify(payload),
    })
  },
})
